
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { changePassword } from '../../actions/index'





import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
    FormGroup,
    Input,
    Row,
    Col,
  } from "reactstrap";







const ChangePasswordModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;

  const state = useSelector(state => state.auth)
  const dispatch = useDispatch()
  

  
  const [modal, setModal] = useState(false);
  const [password,setPassword] = useState('')
  const [confirmPassword,setConfirmPassword] = useState('')

  const toggle = () => setModal(!modal);


  const changePasswordDispatcher = () =>{
    if (password === ""){
        alert('password field is empty')
    }
    if (password !== confirmPassword){
        alert('passwords dont match')
    }
    else{
        dispatch(changePassword(password))
    } 
  }
 

  
  return (
    <div>
      <Input type='button' color="warning" onClick={toggle} value='Change Password'></Input>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Change Password</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">
            <Row>          
                <Col className="pl-4" md="12">
                <FormGroup>
                    <label>New Password</label>
                    <Input type="password" value={password} onChange={e => setPassword(e.target.value)} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}} />
                </FormGroup>
                </Col>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                <FormGroup>
                    <label>Confirm Password</label>
                    <Input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}  style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}} />
                </FormGroup>
                </Col>
            </Row>
            
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <Button color="warning" onClick={changePasswordDispatcher}>Submit</Button>{' '}
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ChangePasswordModal;